import React from 'react';
import { Button } from '@mui/material';

const styles = {
  button: {
    width: '140px',
    fontSize: '12px',
  },
};

function SaveAndCancelButtons({ onCancel, onSave }) {
  return (
    <>
      <Button
        onClick={onCancel}
        color="primary"
        variant="outlined"
        style={styles.button}
      >
        Cancel
      </Button>
      <Button
        onClick={onSave}
        color="primary"
        variant="contained"
        style={styles.button}
      >
        Save
      </Button>
    </>
  );
}

export default SaveAndCancelButtons;
